import React from 'react'
import { Link } from 'react-router-dom'

import { Box, Container, Grid, Button, Paper, Typography } from '@material-ui/core'

const EmptyState = () => {
  const path = `${import.meta.env.BASE_URL}/engage/end-of-cycle-report`
  return (
    <Container maxWidth="md">
      <Box
        component={Paper}
        p={5}
        mt={5}
      >
        <Grid
          container
          spacing={4}
          alignItems="center"
          direction="column"
        >
          <Grid>
            <Typography
              component="h2"
              variant="h2"
            >
              Sorry, an error has occurred. Please try again.
            </Typography>
          </Grid>
          <Grid item>
            <Link to={path}>
              <Button
                variant="contained"
                color="primary"
              >
                Back to End of Cycle Report
              </Button>
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Container>
  )
}

export default EmptyState
